<div class="confirm-dialog-wrapper">
    <div class="confirm-dialog-container">
        <h1 mat-dialog-title class="dialog-title text-center">
            {{ data.title | translate }}
        </h1>

        <div mat-dialog-content class="dialog-content text-center">
            <p>{{ data.message | translate }}</p>
        </div>

        <div mat-dialog-actions class="dialog-actions">
            <button mat-flat-button class="action-button confirm-button" (click)="onConfirm()">
                {{ "Yes" | translate }}
            </button>
            <button mat-flat-button class="action-button cancel-button" (click)="onCancel()">
                {{ "No" | translate }}
            </button>
        </div>
    </div>
</div>